<template>
  <v-col md="6" class="pr-2">
    <v-card elevation="1" class="mb-4">
      <v-card-text :style="'min-height:' + minHeight">
        <h6 class="text-h6 black--text">Información extra</h6>
        <p class="text-body-2">Informacion utilizada para las metricas generadas por el sistema</p>
        <v-row class="mt-0">
          <v-col md="6">
            <v-text-field
              dense
              autocomplete="off"
              data-vv-as="cotizacion dolar"
              label="Cotización del Dolar"
              name="dolar_cotiz"
              placeholder="Cotización del Dolar"
              v-validate="'required|decimal'"
              type="number"
              v-model="item.dolar_cotiz"
              class="mt-3"
              :disabled="isViewModal || openFromPaymentOrder"
            />
            <span class="red--text">{{ errors.first("dolar_cotiz") }}</span>
          </v-col>
      
          
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { currencyService } from "@/libs/ws/currencyService";
export default {
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    item: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
    openFromPaymentOrder: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
      default: "238px",
    },
    show_cost_center: {
      type: Boolean,
      default: false,
    },
    validator: Object,
  },
  created() {
    this.$validator = this.validator;
  },
  data: () => ({}),
  watch: {
    dialog(val) {
      if (val) {
        this.loadComboData();
      }
    },
  },
  mounted() {
    this.loadComboData(); //el primer edit de dialog no va al watch
  },
  methods: {
    loadComboData() {
      currencyService
        .getUSDPrice()
        .then((response) => {
          this.item.dolar_cotiz = response.result.price;
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrio un error al obtener la cotizacion del dolar.");
        });
    },
  },
};
</script>
